import { Box, Chip, Paper, Typography, useMediaQuery } from "@mui/material"

export default function DifferentiatorSection() {
    const isMobile = useMediaQuery('(max-width:950px)')

    const styles = {
        container: (isMobile) => ({
            margin: isMobile ? '1.2rem .8rem' : '4rem 14vw',
            padding: isMobile ? '2rem 1.2rem' : '3rem 6vw',
            fontFamily: 'Catamaran',
        }),
        heading: (isMobile) => ({
            fontFamily: 'inherit',
            fontWeight: 800,
            color: 'primary.black',
            textAlign: 'center',
            mb: 2,
            fontSize: isMobile ? '1.8rem' : '2rem',
        }),
        body: {
            fontFamily: 'inherit',
            fontWeight: 500,
            color: 'text.gray',
            textAlign: 'center',
            mb: 1,
            fontSize: '1.1rem',
            maxWidth: '640px',
            mx: 'auto',
        },
        bodyAccent: {
            fontFamily: 'inherit',
            fontWeight: 600,
            color: 'primary.black',
            textAlign: 'center',
            mb: 5,
            fontSize: '1.1rem',
        },
        cardsContainer: (isMobile) => ({
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: 3,
            justifyContent: 'center',
            maxWidth: '700px',
            mx: 'auto',
        }),
        card: {
            flex: 1,
            borderRadius: '32px',
            p: '2rem 2.5rem',
            textAlign: 'center',
        },
        cardLabel: {
            fontFamily: 'inherit',
            fontWeight: 800,
            fontSize: '1.3rem',
            mb: 1.5,
        },
        cardText: {
            fontFamily: 'inherit',
            fontWeight: 500,
            fontSize: '1.05rem',
            color: 'text.gray',
        },
    }

    return (
        <Box id="why-vibio" sx={styles.container(isMobile)}>
            <Chip
                label="Why Vibio"
                size="small"
                sx={{
                    display: 'flex',
                    width: 'fit-content',
                    m: '0 auto 1rem auto',
                    fontFamily: 'Catamaran',
                    fontWeight: 700,
                    backgroundColor: 'primary.main',
                    color: '#fff',
                }}
            />
            <Typography
                variant={isMobile ? 'h4' : 'h3'}
                component="h2"
                sx={styles.heading(isMobile)}
            >
                You have a strong brand
                <br />
                let Vibio make it stronger
            </Typography>
            <Typography
                variant="body1"
                component="p"
                sx={styles.body}
            >
                Video link in bio helps you draw attention with your work, personality and your energy. And get the insights that really matter to scale your personal brand.
            </Typography>

        </Box >
    )
}
